import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const StyledContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
  position: relative;
  max-width: ${props =>
    props.size === "small"
      ? "768px"
      : props.size === "medium"
      ? "1080px"
      : props.size === "large"
      ? "1140px"
      : "1200px"};
`

const Container = ({ size, children, className }) => {
  let classes = `container container--${size}`

  if (className) {
    classes += ` ${className}`
  }

  return (
    <StyledContainer size={size} className={classes}>
      {children}
    </StyledContainer>
  )
}

Container.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large", "xlarge"]),
  className: PropTypes.string,
}

Container.defaultProps = {
  size: "medium",
}

export { Container }
